import React, { useState } from 'react';
import { 
  Box,
  TextField,
  Alert,
  IconButton,
  InputAdornment,
  Toolbar,
} from '@mui/material';
import { supabase } from '../configs/supabase';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { validateEmail } from '../utils/validate';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../features/auth/AuthContext';
import { routingPath } from '../utils/path';
import FoodLogo from '../assets/food-logo.png';
import { ValidationError, AuthenticationError } from '../utils/ErrorClass';
import { StyledButton, StyledPaper } from '../utils/theme';
import { GradientText } from '../utils/theme';

export default function LoginPage() {
  const [id, setId] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { state, dispatch } = useAuthContext();

  const togglePasswordVisibility = () => { setShowPassword(!showPassword) };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const email = validateEmail(id) ? id : `${id}@tano-meshi.com`;
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        throw new AuthenticationError('IDとパスワードが一致しません');
      };
  
      if (data) {
        dispatch({ type: 'SET_CUSTOMER_ID', payload: state.customerId});
        navigate(routingPath.auth.orderList);
      }
    } catch (err) {
      if (err instanceof ValidationError) {
        setEmailError(err.message);
      } else if (err instanceof AuthenticationError) {
        setError(err.message);
      } else { 
        setError('予期せぬエラーが発生しました。');
      }
    }
  };

  return (
    <>
      <Toolbar />
      <StyledPaper sx={{ maxWidth: 500, minWidth: 350, mx: 'auto', p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img src={FoodLogo} alt="Food Logo" style={{ marginRight: '14px', width: '48px', height: '48px' }} />
          <GradientText style={{ fontSize: 24, marginTop: 10 }}>たのメシ.com</GradientText>
        </Box>
        {process.env.REACT_APP_ENVIRONMENT === 'LOCAL' && <GradientText style={{ fontSize: 20, marginTop: 10 }}> - 開発用 - </GradientText>}
        {process.env.REACT_APP_ENVIRONMENT === 'STAGING' && <GradientText style={{ fontSize: 20, marginTop: 10 }}> - ステージング - </GradientText>}
        {process.env.REACT_APP_ENVIRONMENT === 'NAKANO' && <GradientText style={{ fontSize: 20, marginTop: 10 }}> - 中野外食様専用 - </GradientText>}
        <Box 
          component="form" 
          onSubmit={handleSubmit} 
          noValidate 
          sx={{ 
            mt: 1, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center' 
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center'}}>
            <TextField
              margin="normal"
              required
              id="id"
              label="id"
              name="id"
              autoFocus
              value={id}
              onChange={(e) => setId(e.target.value)}
              error={!!emailError}
              helperText={emailError}
              sx={{ maxWidth: 130, mr: 2 }}
            />
            @tano-meshi.com
          </Box>
          <TextField
            margin="normal"
            required
            // fullWidth
            name="password"
            label="password"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={togglePasswordVisibility}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            }}
            sx={{ maxWidth: 400, minWidth: 290 }}
          />
          <StyledButton
            type="submit"
            fullWidth
            variant="contained"
          >
            ログイン
          </StyledButton>
          {error && <Alert severity="error" sx={{ width: '100%', mt: 3 }}>{error}</Alert>}
        </Box>
        {/* 偽のメールアドレス文字列のためパスワード変更はクライアント側からは不可にする */}
        {/* <Typography variant="body2" sx={{ mt: 2 }}>
          パスワードを忘れた方は
          <StyledLinkButton onClick={() => navigate(routingPath.sendEmail)}>
            こちら
          </StyledLinkButton>
        </Typography> */}
      </StyledPaper>
    </>
  );
};
